import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery'

class LokalniVzdalenaSpravaSiti extends Component {
    componentDidMount(){


        function resetMenu(){
            $("#home a").removeClass("active");

            $("#sluzby-a-produkty-link").removeClass("active");
            $("#prodej-instalace-li").removeClass("active");
            $("#lokalni-li").removeClass("active");
            $("#outsourcing-li").removeClass("active");
            $("#audit-is-li").removeClass("active");
            $("#webhosting-li").removeClass("active");
            $("#webdesign-li").removeClass("active");
            $("#cenik-praci-li").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#lokalni-li").addClass("active");
        $("#basic-nav-dropdown").addClass("active");


    }
  render() {
    return (
<div>


        <div className="container content fade-in two">
            <h1>Lokální a vzdálená správa sítí</h1>


            Komplexní aktivní správa sítě představuje pravidelné nebo vyžádané servisní návštěvy. Pravidelné návštěvy pak umožňují předcházet nestabilitě a bezpečnostním rizikům systému a v neposlední řadě navrhovat obnovu IT vybavení. Je možné si domluvit i tzv. vzdálenou správu. Výhodou služby aktivní správa sítě je zejména nižší finanční náročnost bez nutnosti fixace vyšších finančních prostředků na zabezpečení a odborné profesní zajištění vlastního správce.
<br/><br/>
            <h2><b>Jedná se zejména o tyto instalace a optimalizace SW a HW:</b></h2>
            <li>Administrativní úkony v běžných operačních systémech</li>
<ul>
    <li>Konfigurace systémů</li>
        <li>Instalace nových produktů</li>
            <li>Upgrady, patche apod.</li>
                <li>Preventivní údržba</li>
                    <li>Změny uživatelské databáze</li>
</ul>
            <li>Zálohování dat</li>
                <li>Ochrana proti úmyslnému či neúmyslnému poškození, úniku nebo ztrátě dat</li>
                    <li>Ochrana dat proti virům</li>
                        <li>Preventivní údržba, výkonnostní ladění</li>
                            <li>Zajišťování rozvoje sítě s ohledem na potřeby firmy a dostupné technologie</li>
                                <li>Servisní zásahy s garantovanou dobou odezvy i garantovaným časem zásahu</li>
                                    <li>Hot-Line podpora zdarma</li>
                                        <li>V případě potřeby práce mimo pracovní dobu, o svátcích a víkendech</li>
            <br/><br/>
            Online správa výpočetní techniky umožňuje zajišťovat veškerou bezpečnostní politiku i z jiného bodu, než pouze z areálu klientova závodu či kanceláře. Tímto způsobem se zajišťují nejenom správy uživatelských účtů, ale i instalace, zálohy, bezpečnostní a antivirová politika apod. Rozsah zásahů vždy záleží na dohodě mezi poskytovatelem a dodavatelskou firmou. Zásahy do kritických míst firmy se dějí v době, kdy není omezena žádná pracovní či výrobní činnost firmy.  Vzdálená správa neumí odbourat zásahy na opravu či údržbu hardware, ale na druhou stranu plně nahradí standardní síťový dohled.
            <br/><br/>
            Více o Bezpečnosti sítí naleznete <Link to="/sluzby-a-produkty/bezpecnost-siti">zde</Link>.


        </div>


</div>
    );
  }
}

export default LokalniVzdalenaSpravaSiti;



// WEBPACK FOOTER //
// ./src/sluzby-a-produkty/LokalniVzdalenaSpravaSiti.js